module.exports = __webpack_public_path__ + "img/ic_invite_gold.51593a15.png";